import ProvincesApiV2 from 'api/v2/admins/provinces-api-v2'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'
import InputField from 'components/molecules/input-field'

const propTypes = {
  name      : PropTypes.string,
  label     : PropTypes.string,
  required  : PropTypes.bool,
  valueType : PropTypes.string
}

const defaultProps = {
  name      : 'province',
  label     : 'Province',
  required  : false,
  valueType : 'id'
}
/**
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {string} valueType - what the form will return value
 */
const ProvinceSelectField = ({
  name,
  label,
  required,
  valueType,
  ...props
}) => {
  const [ provinces, setProvinces ] = useState([])
  const [ isLoading, setIsLoading ] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    ProvincesApiV2.get()
      .then((response) => {
        setProvinces(response.data.tl_provinces)
        setIsLoading(false)
      })
      .catch(() => {
        alert('Failed to fetch Provinces')
      })
  }, [])

  // eslint-disable-next-line react/prop-types
  const SelectFieldOptions = ({ options, label }) => (
    <>
      <option value='' label={ `Choose ${label}` }/>
      {
        // eslint-disable-next-line react/prop-types
        options.map((option) => (
          <option
            key={ `select-option-province-${option.id}` }
            value={ isStringValue(option[valueType]) ? StringUtil.humanizeUpperCase(option[valueType]) : option[valueType] }
            label={ StringUtil.humanizeUpperCase(option.name) }
          />
        ))
      }
    </>
  )

  const isStringValue = (value) => typeof value === 'string' || value instanceof String

  return (
    <InputField
      type='select'
      label={ label }
      name={ name }
      required={ required }
      disabled={ isLoading }
      { ...props }
    >
      {
        isLoading ?
          <option
            key=''
            value=''
            label='Loading...'
          /> :
          <SelectFieldOptions
            options={ provinces }
            label={ label }
          />
      }
    </InputField>
  )
}

ProvinceSelectField.propTypes    = propTypes
ProvinceSelectField.defaultProps = defaultProps

export default ProvinceSelectField
